export default __webpack_public_path__ + "static/media/application.30255ed8.svg";